import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/companySupplyProvideService'
export const namespace = 'companySupplyProvideService'
export const clientRoute = '/company/company-supply-provide-service'
export const dependencies = ['company', 'supplyProvideService']
export const params = {
  include: 'company,supplyProvideService'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'supplyProvideService'
const subtitleColumn = 'Company'
const infoColumns = []
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
